module.exports = __webpack_public_path__ + "img/feature-icon-04.65442326.svg";